// extracted by mini-css-extract-plugin
export default {"root":"classes_root__9RcDv","avatar":"classes_avatar__cQzC8","pro-badge":"classes_pro-badge__bJVq1"};